//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StarRating from 'vue-star-rating'
import FeedbackForm from '@/utils/FeedbackForm'
import FormPart from './form-parts/FormPart'
import SuccessAlert from './SuccessAlert'
import Loader from '../Loader'
import CalendarIcon from './icons/Calendar'
import LocationIcon from './icons/Location'
import API from '@/services/API'

export default {
    components: {
        StarRating,
        FormPart,
        SuccessAlert,
        Loader,
        CalendarIcon,
        LocationIcon,
    },
    props: {
        feedback: { type: Object, required: true },
        score: { type: Number, default: null },
    },
    data() {
        return {
            showModal: true,
            globalRate: null,
            loading: {
                form: false,
            },
            answers: null,
            error: null,
            form: null,
            feedbackStatus: null,
            primaryColor: '#093B59',
        }
    },
    watch: {
        showModal: function() {
            this.handleBodyScroll()
        },
    },
    computed: {
        isFinished: function() {
            return this.feedbackStatus === 'done'
        },
        isFirstStep: function() {
            if (this.form && this.form.formStep) {
                return this.form.formStep === 1
            } else {
                return true
            }

            // if (this.feedback && this.feedback.form && this.feedback.form.form_step) {
            //     return this.feedback.form.form_step === 1
            // } else {
            //     return false
            // }
        },
        speakersSentence: function() {
            if (
                this.feedback &&
                this.feedback.event &&
                this.feedback.event.speakers &&
                this.feedback.event.speakers.length
            ) {
                return 'With ' + this.feedback.event.speakers.map(speaker => speaker.name).join(', ')
            } else {
                return null
            }
        },
        bgEvent: function() {
            return {
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(255, 255, 255, 1)), url("${this.feedback.event.picture}")`,
            }
        },
    },
    mounted() {
        this.handleBodyScroll()
        this.handleFeedback(this.feedback)

        if (this.score) {
            const element = this.feedback.form.form_elements.find(formEl =>
                formEl.type === 'global-rate' ? formEl : null
            )
            if (element !== null) {
                this.form.setAnswer(element.id, this.score)
            }
        }
    },
    methods: {
        handleBodyScroll() {
            if (this.showModal) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = 'visible'
            }
        },
        handleFeedback(feedback) {
            if (feedback) {
                this.form = new FeedbackForm(feedback.form)
                this.feedbackStatus = feedback.status
            }

            this.loading.form = false
        },
        onClick(formEl) {
            this.form.setAnswer(formEl.id, true)
            this.sendAnswers()
        },
        onAnswer(answer) {
            this.form.setAnswer(answer.id, answer.answer)
        },
        sendAnswers() {
            this.loading.form = true
            this.globalRate = this.form?.globalRateValue

            API.postFeedbackAnswers(this.feedback.id, this.form?.feedbackAnswersObject)
                .then(data => {
                    this.handleFeedback(data)
                })
                .catch(err => {
                    this.error = err
                    this.showModal = false
                })
        },
        dismiss: function() {
            this.showModal = false
        },
        goBack() {
            this.loading.form = true

            API.getFeedbackBack(this.feedback.id, this.form?.form.form_step)
                .then(data => {
                    this.handleFeedback(data)
                })
                .catch(err => {
                    this.error = err
                    this.showModal = false
                })
        },
        formatDateFr(date) {
            const d = new Date(date)

            const day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
            const month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
            const year = d.getFullYear()

            return day + '/' + month + '/' + year
        },
        getCookie(cname) {
            const name = cname + '='
            const decodedCookie = decodeURIComponent(document.cookie)
            const ca = decodedCookie.split(';')

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i]
                while (c.charAt(0) === ' ') {
                    c = c.substring(1)
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length)
                }
            }
            return ''
        },
    },
}
